
export class SearchPitOpeCriteria {

    numOpe!: number;
    numOpeExt!: string;
    nom!: string;
    codePostal!: string;
    ville!: string;

}


